import { render, staticRenderFns } from "./UserFormFields.vue?vue&type=template&id=0b2065c6&scoped=true"
import script from "./UserFormFields.vue?vue&type=script&lang=js"
export * from "./UserFormFields.vue?vue&type=script&lang=js"
import style0 from "./UserFormFields.vue?vue&type=style&index=0&id=0b2065c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2065c6",
  null
  
)

export default component.exports